import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-6 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 pb-2 text-left" }, null, -1)
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-2 pb-2 text-left" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "mt-2 pb-2 text-left" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDailyReportFilterDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const selectedSync = ref({
  label: "ALL",
  value: "",
});
const moduleCode = ref(
  process.env.VUE_APP_NON_GAME_PROVIDER_MODULE_CODE?.toUpperCase().split(",").map((providerCode) => {
    if (providerCode !== "AFFILIATE_COMISSION")
      return {
        value: providerCode,
        label: providerCode
      }
  }).filter((moduleList) => moduleList)
);

const onOptionSelected = (e: any) => {
  console.log(e)
  selectedSync.value = e;
  emit("update:form", { ...props.form, moduleCode: e.value });
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.userActivityLog.advanceFilter")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.paymentDailyReport.moduleCode")), 1),
                        _createVNode(DropdownComponent, {
                          class: "w-full",
                          options: moduleCode.value,
                          modelValue: selectedSync.value,
                          onOnOptionSelected: onOptionSelected
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.paymentDailyReport.depositCount")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((__props.form as any).depositCount) = $event)),
                            name: "depositCount",
                            id: "depositCount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).depositCount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.paymentDailyReport.depositAmount")), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((__props.form as any).depositAmount) = $event)),
                            name: "depositAmount",
                            id: "depositAmount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).depositAmount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("messages.paymentDailyReport.withdrawCount")), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((__props.form as any).withdrawCount) = $event)),
                            name: "withdrawCount",
                            id: "withdrawCount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).withdrawCount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.paymentDailyReport.withdrawAmount")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((__props.form as any).withdrawAmount) = $event)),
                            name: "withdrawAmount",
                            id: "withdrawAmount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, (__props.form as any).withdrawAmount]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('submit', 1))),
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.userActivityLog.filter")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.userActivityLog.cancel")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})